<script setup lang="ts"></script>
<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.496"
        height="21.5"
        viewBox="0 0 16.496 21.5"
        fill="currentColor"
        stroke="currentColor">
        <path
            id="shopping-bag_black"
            d="M8,0A4.311,4.311,0,0,0,3.691,4.307v.615H0V21H16V4.922H12.3V4.307A4.311,4.311,0,0,0,8,0ZM4.922,4.307a3.076,3.076,0,1,1,6.152,0v.615H4.922Zm9.844,1.846V19.77H1.23V6.152H3.691V8.613h1.23V6.152h6.152V8.613H12.3V6.152Zm0,0"
            transform="translate(0.25 0.25)"
            stroke-width="0.5" />
    </svg>
</template>
